import React from 'react';
import { Divider } from 'antd';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../../hoc/Localization';
import styles from './styles.less';

const SalaryRange = ({ salary }) => {
  const { t } = React.useContext(LocalizationContext);
  return (
    <div className={styles.wrapper}>
      <h3>{t('paths.experience.salary')}</h3>
      <div className={styles.salaryGraph}>
        <div>
          <div className={styles.salaryGraphFirst}>
            <div className={styles.firstShape} />
            <p>{salary[0].title}</p>
            <p className={styles.secondP}>
              {t('path.up.to')}
              {' '}
              {salary[0].amountEnd}
              {' '}
              AMD
            </p>
          </div>
          <Divider className={styles.divider} />
        </div>
        <div>
          <div className={styles.salaryGraphMiddle}>
            <div className={styles.secondShape} />
            <p>{salary[1].title}</p>
            <p className={styles.secondP}>
              {salary[1].amountStart}
              {' '}
              -
              {' '}
              {salary[1].amountEnd}
              {' '}
              AMD
            </p>
          </div>
          <Divider className={styles.divider} />
        </div>
        <div>
          <div className={styles.salaryGraphMiddle}>
            <div className={styles.thirdShape} />
            <p>{salary[2].title}</p>
            <p className={styles.secondP}>
              {salary[2].amountStart}
              {' '}
              -
              {' '}
              {salary[2].amountEnd}
              {' '}
              AMD
            </p>
          </div>
          <Divider className={styles.divider} />
        </div>
        <div className={styles.salaryGraphLast}>
          <div className={styles.fourthShape} />
          <p>{salary[3].title}</p>
          <p className={styles.secondP}>
            {salary[3].amountStart}
            {' '}
            -
            {' '}
            {salary[3].amountEnd}
            {' '}
            AMD
          </p>
        </div>
      </div>
    </div>
  );
};

SalaryRange.propTypes = {
  salary: PropTypes.object.isRequired,
};

export default SalaryRange;
